import { useState } from "react";
import { Gauge } from "lucide-react";
import Sidebar from "@/components/sidebar.jsx";
import FleetOverview from "@/components/fleet-overview.jsx";
import MobileMenuButton from "@/components/ui/mobile-menu-button.jsx";
import PageHeader from "@/components/page-header.jsx";
import PageHeaderActions from "@/components/page-header-actions.jsx";
import { cardStyles } from "@/lib/status-styles.js";

/**
 * Dashboard page component that displays the fleet runtime overview
 * Contains sidebar navigation and main fleet overview content
 * @returns {JSX.Element} Dashboard page with sidebar and fleet overview
 */
export default function Dashboard() {
  /** @type {[boolean, Function]} */
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className='flex h-screen bg-background relative'>
      {/* Mobile menu button */}
      <MobileMenuButton
        isOpen={isMobileMenuOpen}
        onToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      {/* Sidebar */}
      <Sidebar
        key='persistent-sidebar'
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />

      {/* Main Content - min-h-0 so flex child can shrink and show scrollbar */}
      <div className='flex-1 flex flex-col min-h-0 overflow-hidden transition-all duration-200 ease-in-out'>
        <PageHeader
          icon={Gauge}
          title='Fleet Runtime Overview'
          subtitle='Real-time monitoring of compressor fleet operations'>
          <PageHeaderActions showLastUpdated />
        </PageHeader>

        {/* Main content — fill viewport; page scrolls when table min-height needs more room */}
        <div className={cardStyles.pageContent}>
          <FleetOverview />
        </div>
      </div>
    </div>
  );
}
